const bio =
  "Software Engineer with five years of experience developing enterprise software. Passionate about building scalable applications using Java and modern web technologies while continuously expanding my expertise in React, Node.js, Cloud and DevOps.";

export default bio;
